import React from "react";

const Evening = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M26.777 20.021c-4.3 0-7.8-3.499-7.8-7.8A7.766 7.766 0 0 1 23.84 5c-5.352.133-9.664 4.528-9.664 9.911 0 .367.021.728.06 1.085a7.604 7.604 0 0 1 4.275 2.072 6.33 6.33 0 0 1 3.931 2.71c1.895.47 3.36 1.963 3.855 3.797 4.33-.988 7.59-4.816 7.704-9.414a7.767 7.767 0 0 1-7.222 4.86Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M25.73 24.687c-.459-1.654-1.803-2.99-3.53-3.377l-.117-.026-.064-.1a5.75 5.75 0 0 0-3.707-2.57l-.084-.018-.06-.06a7.039 7.039 0 0 0-3.85-1.948 6.934 6.934 0 0 0-.596-.071 7.255 7.255 0 0 0-.535-.026 7.045 7.045 0 0 0-6.607 4.531l-.065.168-.178.015C3.905 21.412 2 23.487 2 25.93a4.75 4.75 0 0 0 4.746 4.746c.978 0 1.918-.298 2.72-.862l.147-.103.158.086a7.1 7.1 0 0 0 3.417.878c1.09 0 2.146-.249 3.137-.739l.077-.038.085.01c.262.031.48.046.687.046.383 0 .768-.04 1.147-.115l.117-.024.099.066c.779.52 1.686.794 2.625.794a4.746 4.746 0 0 0 4.74-4.74 4.827 4.827 0 0 0-.172-1.247Z"
            fill={fill}
        />
    </svg>
);

export default Evening;
